/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Carriage.scss";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";
import Input from "../../../Common/components/Inputs/Input/Input";
import TrianglePointer from "../../../Common/components/Icons/TrianglePointer/TrianglePointer";
import { selectMechanics, setMechanics, setSelectedMechanicsField } from "../../store/slices/cartesian";
import { CARRIAGE_DISTANCE_FIELD } from "../../../Common/utils/api/common";
import t from "../../../Common/utils/translation/translator";

const CARRIAGE_QUANTITY = "quantityCarriages";
const CARRIAGE_DISTANCE = "distanceBetweenCarriages";
const CARRIAGE_CONNECTED = "carriageConnected";
const INCREMENT = "increment";
const DECREMENT = "decrement";

const getFocusText = (name) => {
  switch (name) {
    case CARRIAGE_DISTANCE:
      return CARRIAGE_DISTANCE_FIELD;
    case CARRIAGE_CONNECTED:
      return t("cartesian.ui.mechanics.connected_carriages");
    default:
      return "";
  }
};

const DoubleAxisChoiceSection = ({
  distance,
  handleDistanceChange,
  connected,
  handleConnectedChange,
  onfocusin,
  onfocusout,
  ...props
}) => (
  <>
    <div className="DoubleAxisChoiceSection flex flex-col w-full" {...props}>
      <TrianglePointer data-testid="triangle-pointer-double-axis-choice-section" inputClasses="pl-[190px]" />
      <div className="flex-item-double-axis w-full">
        <div className="flex flex-col w-1/3">
          <DoubleAxisDistanceCarriageSection
            data-testid="double-axis-distance-carriage-section"
            value={distance}
            onChange={handleDistanceChange}
            onfocusin={onfocusin}
            onfocusout={onfocusout}
          />
          {/*  <DoubleAxisConnectedCarriageSection data-testid="double-axis-connected-carriage-section" checked={connected} onChange={handleConnectedChange} /> */}
        </div>
      </div>
    </div>
  </>
);

const DoubleAxisDistanceCarriageSection = ({ value, onChange, onfocusin, onfocusout, ...props }) => {
  return (
    <div className="DoubleAxisDistanceCarriageSection pb-4 pt-2 pl-4" {...props}>
      <Input
        data-testid={`input-${CARRIAGE_DISTANCE}`}
        type="number"
        pattern="^\d+(\.\d{1,2})?$"
        autoComplete="off"
        required
        name={CARRIAGE_DISTANCE}
        value={value}
        label={t("cartesian.ui.mechanics.distance_between_carriages")}
        unit="mm"
        classes="carriage-typography"
        onChange={onChange}
        placeHolder="-"
        inputClasses="hide-arrow"
        unitClasses="input_unit"
        labelRequired
        invalidText={t("cartesian.ui.mechanics.distance_between_carriages_error")}
        isInvalid={value % 1 !== 0 || value < 35 || value > 999}
        onfocusin={onfocusin}
        onfocusout={onfocusout}
      />
    </div>
  );
};

const DoubleAxisConnectedCarriageSection = ({ checked, onChange, ...props }) => (
  <div className="DoubleAxisConnectedCarriageSection flex flex-row" {...props}>
    <div className="pl-4 pb-2">
      <input type="checkbox" id="connected" name={CARRIAGE_CONNECTED} checked={checked} onChange={onChange} />
      <span className="carriage-typography pl-1">{t("cartesian.ui.mechanics.connected_carriages")}</span>
    </div>
  </div>
);

const CarriageQuantityInputSection = ({ value, onChange, ...props }) => (
  <div className="CarriageQuantityInputSection flex flex-row items-center mb-1" {...props}>
    <span className="carriage-typography flex flex-row items-center mr-4">
      {t("cartesian.ui.mechanics.quantity_of_carriages")}
      <span className="light-error-active">*</span>
    </span>
    <div className="h-9 flex flex-row">
      <div className="w-20 numberInput">
        <input
          className="w-full h-full border-0 text-center border-transparent focus:border-transparent focus:ring-0"
          type="text"
          value={value}
          name={CARRIAGE_QUANTITY}
          onKeyDown={(event) => {
            event.preventDefault();
          }}
          onChange={(event) => {
            event.preventDefault();
          }}
        />
      </div>
      <div className="w-5 button-box flex flex-col">
        <div
          id={INCREMENT}
          title={CARRIAGE_QUANTITY}
          className={`button-inc-dec mt-[1px] cursor-pointer ${value === 3 ? "bg-gray-300" : "bg-[#42B4E6]"}`}
          onClick={(e) => onChange(e)}
        >
          <FiChevronUp />
        </div>
        <div
          id={DECREMENT}
          title={CARRIAGE_QUANTITY}
          className={`button-inc-dec mt-[1px] mb-[1px] cursor-pointer ${value === 1 ? "bg-gray-300" : "bg-[#42B4E6]"}`}
          onClick={(e) => onChange(e)}
        >
          <FiChevronDown />
        </div>
      </div>
    </div>
  </div>
);

const CarriageQuantitySection = ({ ...props }) => {
  const dispatch = useDispatch();
  const mechanics = useSelector(selectMechanics);

  const handleInputFocusIn = (event) => {
    const { name } = event.target;
    dispatch(setSelectedMechanicsField(getFocusText(name)));
  };

  const handleInputFocusOut = () => {
    /*
    const newData = {
      ...mechanics,
      selectedField: ""
    };
    dispatch(setMechanics(newData));
    */
  };

  const handleInputChange = (event) => {
    const { name, value, checked } = event.target;
    let changedVal = value;

    if (name === CARRIAGE_CONNECTED) {
      changedVal = checked;
    }

    if (name === CARRIAGE_DISTANCE) {
      changedVal = parseInt(changedVal);
      event.target.value = changedVal;
    }

    const newData = {
      ...mechanics,
      [name]: changedVal
    };
    dispatch(setMechanics(newData));
  };

  const incrementDecrement = (event) => {
    const { title, id } = event.currentTarget;
    let newVal = mechanics.quantityCarriages;
    if (id === INCREMENT && newVal < 3) {
      newVal += 1;
    }
    if (id === DECREMENT && newVal > 1) {
      newVal -= 1;
    }
    const newData = {
      ...mechanics,
      [title]: newVal
    };
    dispatch(setMechanics(newData));
  };

  return (
    <div className="CarriageQuantitySection mt-6 mb-6 w-full" {...props}>
      <div className="flex flex-col w-full">
        <CarriageQuantityInputSection
          data-testid="carriage-quantity-input-section"
          value={mechanics.quantityCarriages}
          onChange={incrementDecrement}
        />

        {mechanics?.quantityCarriages > 1 ? (
          <DoubleAxisChoiceSection
            data-testid="double-axis-choice-section"
            distance={mechanics.distanceBetweenCarriages}
            handleDistanceChange={handleInputChange}
            connected={mechanics?.carriageConnected}
            handleConnectedChange={handleInputChange}
            onfocusin={handleInputFocusIn}
            onfocusout={handleInputFocusOut}
          />
        ) : null}
      </div>
    </div>
  );
};

export default CarriageQuantitySection;
